// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptionName_container__CHH-n","name":"DescriptionName_name__2BXTm"};